module.exports = __webpack_public_path__ + "img/chinesecompany171.011c3363.png";